import axiosClient from "./axiosClient.js";

const savedFilterViewApi = {
  getByStaffId: (staffId) => {
    const url = `/saved-views/getByStaffId/${staffId}`;
    return axiosClient.get(url);
  },
  create: (data) => {
    const url = `/saved-views/create`;
    return axiosClient.post(url, data);
  },
  updateById: (id, data) => {
    const url = `/saved-views/update/${id}`;
    return axiosClient.put(url, data);
  },
  deleteById: (id) => {
    const url = `/saved-views/delete/${id}`;
    return axiosClient.delete(url);
  },
};

export default savedFilterViewApi;
